import React, { useState, useEffect } from "react";
import { useUser, fetchWithAuth } from "../../Context/UserContext";
import { useNavigate } from "react-router-dom";
import { TopProgressBar } from "../../components/ui/progress-bar";
import PageLayout from "../../components/layout/PageLayout";
import FiltroLicitacionesPropias from "./FiltroLicitacionesPropias";
import InfoLicitacionesPropias from "./InfoLicitacionesPropias";
import API_URL from "../../config";
import { Helmet } from "react-helmet-async";
import { toast } from "sonner";

const AdminLicitacion = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [tenders, setTenders] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    categoria: "",
    ciudad: "",
    condiciones_pago: "",
    duracion_contrato: "", // Nuevo filtro
    fecha: "",
  });

  // Verificar si el usuario está autenticado
  useEffect(() => {
    const currentUserId = localStorage.getItem("current_user_id");
    const accessToken = localStorage.getItem(`access_token_${currentUserId}`);

    if (!currentUserId || !accessToken) {
      toast.warning("No estás autenticado. Serás redirigido al inicio de sesión.");
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchTenders(page, filters);
    }
  }, [page, filters]);

  const fetchTenders = async (page, filters) => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams({
        page,
        ...(filters.categoria && { categoria: filters.categoria }),
        ...(filters.ciudad && { ciudad: filters.ciudad }),
        ...(filters.condiciones_pago && {
          condiciones_pago: filters.condiciones_pago,
        }),
        ...(filters.duracion_contrato && {
          duracion_contrato: filters.duracion_contrato,
        }),
        ...(filters.fecha && { fecha: filters.fecha }),
      });

      const response = await fetchWithAuth(
        `${API_URL}/licit/get_owners_tenders?${params.toString()}`
      );

      if (response.ok) {
        const { tenders, pages, total } = await response.json();
        setTenders(tenders);
        setTotalPages(pages);
        setTotalResults(total);
      } else {
        console.error("Error al obtener las licitaciones", response.statusText);
        toast.error("No se pudieron cargar tus licitaciones. Intenta de nuevo.");
      }
    } catch (error) {
      console.error("Error al obtener las licitaciones", error);
      toast.error("No se pudieron cargar tus licitaciones. Intenta de nuevo.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageLayout>
      <Helmet>
        <title>Administrar Licitaciones - Procu</title>
        <meta
          name="description"
          content="Administra tus licitaciones en Procu. Gestiona, filtra y encuentra oportunidades de negocio fácilmente con nuestra plataforma B2B."
        />
        <meta name="keywords" content="licitaciones, administración, negocios, proveedores, Procu, B2B, oportunidades" />
      </Helmet>
      <TopProgressBar isLoading={isLoading} />

      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
        <FiltroLicitacionesPropias filters={filters} setFilters={setFilters} setPage={setPage} />
        <InfoLicitacionesPropias
          tenders={tenders}
          page={page}
          totalPages={totalPages}
          totalResults={totalResults}
          setPage={setPage}
        />
      </div>
    </PageLayout>
  );
};

export default AdminLicitacion;
